import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './login.module.css';

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const hardcodedPassword = '!S4/@m33h'; 

    if (password === '') {
      setError('Password is required.');
      return;
    }

    if (password !== hardcodedPassword) {
      setError('Incorrect password.');
      return;
    }

    setError('');
    onLogin();
    setPassword('');
    navigate('/homepage');
  };

  return (     
    <div className={styles.logincontainer}>
      {error && <p className={styles.errormessage}>{error}</p>}
      <form className={styles.loginform} onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          onChange={handleChange}
          placeholder="Enter your password"
          required
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;